import { useConnectionEventLog } from '~/hooks/useConnectionEventLog'
import { useWebSocketHeartbeat } from '~/hooks/useWebSocketHeartbeat'

/**
 * Headless listener that keeps the connection-diagnostics bridges mounted for
 * the lifetime of the authenticated app: it records WebSocket heartbeat
 * liveness and the rolling connection-event log into their atoms (in the
 * JotaiProvider store) so the status panel and the top-nav indicator have
 * fresh data the moment they're opened. Renders nothing — the connection
 * problem surface is now the top-nav chip, not a banner.
 */
export const ConnectionStatusListener = () => {
  useWebSocketHeartbeat()
  useConnectionEventLog()
  return null
}
